export {
  getStaticProps,
  ModernSlaveryHub as default,
} from '@cinch-nx/landing/feature-modern-slavery-hub'
